<div contenteditable="plaintext-only" class="ag-charts-text-input__textarea" tabindex="0"></div>